import { styled } from "nativewind";
import { useEffect, useRef, useState } from 'react';
import { Dimensions, Pressable, ScrollView, StyleSheet, Text, TouchableOpacity, TouchableWithoutFeedback, View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPostUserFittingResultsIdle, fetchPostUserFittingResultsRequest } from '../../store/ducks/app/actions';
import { APIStates } from '../../utils/Strings';
import { editableFittingParamNames, golfBall } from '../../utils/Util';
import MyButton from '../MyButton';
import MyPicker from '../Picker';
import {
    pageTitleStyle,
    textScreenDescriptionlStyle
} from '../Styles';
import ComboBox from "../ComboBox";
import ClubsHeader from "./ClubsHeader";

const StyledView = styled(View);
const StyledText = styled(Text);
const StyledScrollView = styled(ScrollView);
const width = Dimensions.get("screen").width;

export default function GolfBall({  setScreen, currentUser }) {

    const dispatch = useDispatch()
    const postUserFittingResults = useSelector(state => state.app.postUserFittingResults);
    const [refresh, setRefresh] = useState(false)
    const [userId, setUserId] = useState('');
    const [isPickerVisible, setIsPickerVisible] = useState(-1)
    const [inputs, setInputs] = useState(golfBall)
    const [formJson, setFormJson] = useState()

    const scrollRef = useRef(null)
    const balls = ["ball-1","ball-2","ball-3","ball-4","ball-5"]
   
    const setCurrentSelected = (index) => {
        scrollRef.current.scrollTo({ x: 0, y: index * Dimensions.get('screen').height * 0.15 - 100, animated: true })
    }

    const setSelection = (index, value) => {
        const _index = inputs.findIndex((input) => input.index == index);
        inputs[_index].selection = value;
        setRefresh(!refresh)
    };

    return (

        <StyledScrollView
            showsVerticalScrollIndicator={false}
            ref={scrollRef}
            style={{ flex: 1, marginBottom: 0, width: '100%',paddingLeft:'3%',paddingRight:'3%',backgroundColor:'white' }}>


            <View
                key={refresh}
            >
                <ClubsHeader title={"Ai Fitter"}/>
                
                <ComboBox label="Golf Ball Name" items={balls} />
                {inputs.map((data) => {

                    if (data.list) {
                        return (
                            <StyledView
                                key={data.name}
                            >
                                <MyPicker
                                    index={data.index}
                                    key={data.name}
                                    label={data.label.toString()}
                                    name={data.name}
                                    pickerItems={data.pickerItems}
                                    selection={data.selection}
                                    setSelection={setSelection}
                                    setCurrentSelectedIndex={setCurrentSelected}
                                    isPickerVisible={isPickerVisible}
                                    setIsPickerVisible={setIsPickerVisible}
                                />

                            </StyledView>

                        );
                    }
                }
                )}

                <StyledView className='mx-auto pt-2 pb-6'>
                    <MyButton
                        label={"Submit"}
                        theme={"submit"}
                        // onPress={() => onSubmit()}
                    />
                </StyledView>
            </View>
        </StyledScrollView>
    )
};

const style = StyleSheet.create({
    pageHeaderStyle: { flexDirection: 'row', justifyContent: 'space-between' },
    addNewUserButtonStyle: {
        color: 'rgba(87,164,251,1)',
        fontSize: 20,
        marginTop: 7.5,
         
    }
})